import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { AppService } from '../../../services';

@Injectable()
export class UserProjectsService {
  private http = inject(HttpClient);
  private _appService = inject(AppService);


  private headers = new HttpHeaders();
  private projectUrl = this._appService.getServerBaseUrl + '/project';

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {

    this.headers.append("Accept", "*/*")
    this.headers.append("Content-Type", "application/json")
  }

  getUserProjects(from: String, to: String, state: String): Observable<any> {

    const url = `${this.projectUrl}/userprojects`;
    let options = { headers: this.headers, withCredentials: true };

    let params = { initialDate: from, finalDate: to, workingState: state, take: 50 }

    return this.http
      .post(url, params, options)
  }
}
